<template>
  <div>
    <v-toolbar flat dense>
      <v-text-field
        v-model="filter"
        label=""
        :append-icon="filter ? '' : 'mdi-filter'"
        clearable
        clear-icon="mdi-filter-remove"
        class="search"
        @focus="filterFocused = true"
        @blur="filterFocused = false"
      ></v-text-field>
      <v-btn v-show="!filterFocused" text icon @click="onNewFolder()" :title="$t('NAVI_NEW_FOLDER_TT')"><v-icon>mdi-folder-plus-outline</v-icon></v-btn>
      <v-btn v-show="!filterFocused" text icon @click="onNewSearch()" :title="$t('NAVI_NEW_SEARCH_TT')"><v-icon>mdi-magnify-plus-outline</v-icon></v-btn>
      <v-btn v-show="!filterFocused" text icon @click="onNewGroup()" :title="$t('NAVI_NEW_GROUP_TT')"><v-icon>mdi-account-multiple-plus-outline</v-icon></v-btn>
    </v-toolbar>


    <!--  - ->
    <dnd-treeview
      group="dndsearch"
      v-model="dragItems"
      @start="onStart"
      @end="onEnd"
      @move="onMove"
    >
      <template v-slot:prepend="{ item, open }">
        <v-icon>
          {{ item.icon ? item.icon : (open ? 'mdi-folder-open' : 'mdi-folder') }}
        </v-icon>
      </template>
      <template v-slot:label="{ item }">
        <div
            :class="{ 'grey--text text--darken-1': !item.own }"
            @click.prevent="onItemClick(item)"
            @dblclick.prevent="onItemDblClick(item)"
            style="user-select: none;"
        >
          {{ item.label }}{{ item.datatype === 'folder' && item.children ? ` (${item.children.length})` : '' }}
        </div>
      </template>
      <template v-slot:append="{ item }">
        <v-icon @click="openMenu($event, item)">mdi-dots-vertical</v-icon>
      </template>
    </dnd-treeview>
    <!- - -->





<!-- -->
    <v-treeview
      v-model="tree"
      :items="dragItems"
      item-key="key"
      item-text="label"
      hoverable
      activatable
      return-object
      :open.sync="open"
      :active.sync="active"
      @update:open="onUpdateOpen"
      @update:active="onUpdateActive"
    >
      <template v-slot:prepend="{ item, open }">
        <v-icon>
          {{ item.icon ? item.icon : (open ? 'mdi-folder-open' : 'mdi-folder') }}
        </v-icon>
      </template>
      <template v-slot:label="{ item }">
        <draggable :list="dragItems" group="dndsearch" :id="item.key" :data-parent="item.parentKey"  @start="onStart" @end="onEnd">

          <div
            :class="{ 'grey--text text--darken-1': !item.own }"
            @click.prevent="onItemClick(item)"
            @dblclick.prevent="onItemDblClick(item)"
            style="user-select: none;"
          >
            {{ item.label }}{{ item.datatype === 'folder' && item.children ? ` (${item.children.length})` : '' }}
          </div>
        </draggable>
      </template>
      <template v-slot:append="{ item }">
        <v-icon @click="openMenu($event, item)">mdi-dots-vertical</v-icon>
      </template>
    </v-treeview>
    <!-- -->

    <v-card v-if="!items.length">
      <v-card-text class="grey lighten-3">{{ $t('NAVI_SEARCHES_NO_RESULTS') }}</v-card-text>
    </v-card>
    <v-menu
      v-model="contextMenuVisible"
      :position-x="x"
      :position-y="y"
      absolute
      offset-y
    >
      <v-list>
        <template
          v-for="(item, idx) in contextMenuComputed"
        >
          <v-divider
            v-if="item.divider"
            :inset="item.inset"
            :key="idx"
          ></v-divider>
          <v-list-item
            v-else
            :key="idx"
            @click="contextMenuCallback(idx)"
          >
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </template>
      </v-list>
    </v-menu>

    <Dialog ref="dialog" />
    <NameDlg v-if="showNameFolderDlg" :title="$t('NAVI_OVERLAY_HEAD_NEW_FOLDER')" label="" @ok="onCreateFolder($event); showNameFolderDlg = false" @cancel="showNameFolderDlg = false" />
    <NameDlg v-if="showRenameFolderDlg" :title="$t('NAVI_OVERLAY_HEAD_RENAME_FOLDER')" label="" :name="valueRenameFolderDlg" @ok="onRenameFolder($event); showRenameFolderDlg = false" @cancel="showRenameFolderDlg = false" />
    <NameDlg v-if="showRenameSearchDlg" :title="$t('NAVI_OVERLAY_HEAD_RENAME_SEARCH')" label="" :name="valueRenameSearchDlg" @ok="onRenameSearch($event); showRenameSearchDlg = false" @cancel="showRenameSearchDlg = false" />
    <NameDlg v-if="showRenameGroupDlg" :title="$t('NAVI_OVERLAY_HEAD_RENAME_GROUP')" label="" :name="valueRenameGroupDlg" @ok="onRenameGroup($event); showRenameGroupDlg = false" @cancel="showRenameGroupDlg = false" />

  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

import EventBus from '../event-bus'

import Search from '../services/Search'
import Dialog from './common/Dialog'
import NameDlg from './common/NameDlg'
import Folder from '../services/Folder'
import AccountModel from '../models/AccountModel'
import draggable from 'vuedraggable'
// import DndTreeview from './common/DndTreeview'

// import store from '../store'

export default {
  name: 'TreeviewPeople',
  components: {
    Dialog,
    NameDlg,
    draggable,
    // DndTreeview,
  },
  props: [],
  data() {
    return {
      tree: [],
      open: [],
      filter: '',
      filterFocused: false,
      contextMenuVisible: false,
      x: 0,
      y: 0,
      active: [],
      contextItem: null,
      showNameFolderDlg: false,
      showRenameFolderDlg: false,
      showRenameSearchDlg: false,
      showRenameGroupDlg: false,
      valueRenameFolderDlg: '',
      valueRenameSearchDlg: '',
      valueRenameGroupDlg: '',
      isMailing: false,
      dragItems: [],
    }
  },
  computed: {
    ...mapGetters([
      'data',
      'isBusy',
      'user_id',
      'is_admin',
      'getSearchFolders',
      'getFoldersMap',
      // 'getCampaignFolders',
      'getSearches',
      'getFolders',
      'getAccountsById',
      'searchIsInUse',
      'searchUsedInMailings',
      'selectedFolder',
      'accounts',
    ]),
    contextMenuOwn() {
      const self = this
      return [
        // TODO: refactor with functions and not strings ;)
        { datatype: 'folder', title: this.$t('NAVI_RENAME_FOLDER_CM'), callback: (item) => { self.valueRenameFolderDlg = item.label; self.showRenameFolderDlg = true } },
        { datatype: 'folder', title: this.$t('NAVI_DELETE_FOLDER_CM'), callback: this.deleteFolder },
        { datatype: 'group', title: this.$t('NAVI_EXECUTE_GROUP_CM'), callback: 'runGroup' },
        { datatype: 'group', title: this.$t('NAVI_EDIT_GROUP_CM'), callback: 'editGroup' },
        { datatype: 'group', title: this.$t('NAVI_RENAME_GROUP_CM'), callback: (item) => { self.valueRenameGroupDlg = item.label; self.showRenameGroupDlg = true } },
        this.isMailing ? { datatype: 'group', title: this.$t('NAVI_TOMAILING_GROUP_CM'), callback: (item) => { EventBus.$emit('addToMailing', item); } } : null,
        { datatype: 'group', title: this.$t('NAVI_DELETE_GROUP_CM'), callback: 'deleteSearch' },
        { datatype: 'search', title: this.$t('NAVI_EXECUTE_SEARCH_CM'), callback: 'runSearch' },
        { datatype: 'search', title: this.$t('NAVI_EDIT_SEARCH_CM'), callback: 'editSearch' },
        { datatype: 'search', title: this.$t('NAVI_RENAME_SEARCH_CM'), callback: (item) => { self.valueRenameSearchDlg = item.label; self.showRenameSearchDlg = true } },
        this.isMailing ? { datatype: 'search', title: this.$t('NAVI_TOMAILING_SEARCH_CM'), callback: (item) => { EventBus.$emit('addToMailing', item); } } : null,
        { datatype: 'search', title: this.$t('NAVI_DELETE_SEARCH_CM'), callback: 'deleteSearch' },
        { divider: true },
        { title: this.$t('NAVI_NEW_SEARCH_CM'), callback: this.onNewSearch },
        { title: this.$t('NAVI_NEW_GROUP_CM'), callback: this.onNewGroup },
        { title: this.$t('NAVI_NEW_FOLDER_CM'), callback: this.onNewFolder },
      ]
    },
    contextMenuOther() {
      return [
        { datatype: 'group', title: this.$t('NAVI_EXECUTE_GROUP_CM'), callback: 'runGroup' },
        { datatype: 'group', title: this.$t('NAVI_READONLY_GROUP_CM'), callback: 'editGroup' },
        this.isMailing ? { datatype: 'group', title: this.$t('NAVI_TOMAILING_GROUP_CM'), callback: (item) => { EventBus.$emit('addToMailing', item); } } : null,
        { datatype: 'search', title: this.$t('NAVI_EXECUTE_SEARCH_CM'), callback: 'runSearch' },
        { datatype: 'search', title: this.$t('NAVI_READONLY_SEARCH_CM'), callback: 'editSearch' },
        this.isMailing ? { datatype: 'search', title: this.$t('NAVI_TOMAILING_SEARCH_CM'), callback: (item) => { EventBus.$emit('addToMailing', item); } } : null,
      ]
    },

    fullTree() {
      let foldersMap = this.getFoldersMap
      let searches = this.getSearches.slice()
      // extract only (unique) accounts with searches, except the current user
      const accountIds = [...new Set(searches.filter(a => a.user_id != this.user_id).map(a => a.user_id))]
      let accounts = this.getAccountsById(accountIds)
      let missingAcc = accountIds.filter(aid => !accounts.map(b => b.id).includes(aid))
      missingAcc = missingAcc.map(id => {
        const aa = new AccountModel()
        aa.id = id
        aa.fullname = searches.find(s => s.user_id == id).user_name
        aa.name = aa.fullname
        aa.missing = true
        return aa
      })
      accounts = accounts.concat(missingAcc)
      accounts.sort((a, b) => ('' + a.fullname).localeCompare(b.fullname)) // sort by FullName
      // prepend current user
      accounts = this.getAccountsById([this.user_id]).concat(accounts)

      const res = accounts.map(a => {
        Vue.set(a, 'key', 'a' + a.id)
        a.label = `${a.fullname}`
        // a.label = `${a.fullname} (${a.id})`
        Vue.set(a, 'children', this.mapRootFoldersAndSearches(a, foldersMap, searches))
        a.datatype = 'account'
        a.parentKey = null
        a.own = (a.id === this.user_id) || this.is_admin
        a.user_id = a.id
        a.icon = a.own ? 'mdi-account' : a.missing? 'mdi-account-off-outline' : 'mdi-account-outline'
        return a
      })
      return res
    },
    items() {
      return this.filter ? this.filterTree(this.fullTree) : this.fullTree
    },
    contextMenuComputed() {
// console.log(this.contextItem)
      if (!this.contextItem) {
        return
      }
// console.log(this.contextItem);
      let contextMenu = this.contextItem.own ? this.contextMenuOwn : this.contextMenuOther
      return contextMenu.filter(a => a && (!a.datatype || !this.contextItem || a.datatype === this.contextItem.datatype))
    },
  },
  watch: {
    items(val) {
      this.dragItems = val
    },
    getFolders() {
// console.log('watch getFolders', val)
      const tkey = 'a' + this.user_id
      const item = this.fullTree.find(a => a.key === tkey)
      if (item) {
        this.open = [item]
      }
    },
    '$route'(route) {
// console.log('$route', route)
      this.isMailing = route.name === 'mailing' || route.name == 'campaign.mailing'
      // var newUser = this.$store.state.route.params.userName;
      // this.$store.dispatch('searchingUser', newUser);
    },
  },
  mounted() {
    if (this.user_id) {
      const tkey = 'a' + this.user_id
      const item = this.fullTree.find(a => a.key === tkey)
      if (item) {
        this.open = [item]
      }
    }
    this.isMailing = this.$route.name === 'mailing' || this.$route.name == 'campaign.mailing'
    this.dragItems = this.fullTree
  },
  methods: {
    findTreeItem (items, id) {
        if (!items) {
            return;
        }
        for (var i = 0; i < items.length; i++) {
            var item = items[i];
            // Test current object
            if (item.key === id) {
                return item;
            }
            // console.log('parent:', item.key, '    children:', item.children && item.children.map(c => c.id) || 0)
            // Test children recursively
            const child = this.findTreeItem(item.children, id);
            if (child) {
                return child;
            }
        }
    },
    compItems (a, b) {
      let res = ('' + a.datatype).localeCompare(b.datatype)
      if (res == 0) {
        res = ('' + a.name).localeCompare(b.name)
      }
      return res
    },
    onMove(evt) {
      console.log('onMove:', evt)
      // evt.preventDefault()
      // var fromParent = itemSelected.parentKey ? this.findTreeItem(this.dragItems, itemSelected.parentKey) : null;
      // var toParent = this.findTreeItem(this.dragItems, evt.to.id);
      // var objFrom = fromParent ? fromParent.children : this.dragItems;
      return false
    },
    clone(item){
      return item
      // const res = {
      //   id: item.id,
      //   value: item.id,
      //   name: item.name,
      //   text: item.name,
      // }
      // return res
    },
    // onClone (item) {
    //   console.log('onClone:', item)
    //   return item
    // },
    onStart(evt) {
      this.active = [];
      const activeItem = this.findTreeItem(this.dragItems, evt.from.id)
      this.active.push(activeItem)
      this.$store.commit('setDndActive', this.active)
      console.log('checkStart - activeItem:', evt.from.id, activeItem)
    },
    onEnd(evt) {
      var itemSelected = this.active[0];
      var fromParent = itemSelected.parentKey ? this.findTreeItem(this.dragItems, itemSelected.parentKey) : null;
      console.log('evt.to:',  evt.to)

      var toParent = this.findTreeItem(this.dragItems, evt.to.id);
      var objFrom = fromParent ? fromParent.children : this.dragItems;

      console.log('onEnd - fromParent -> toParent:', fromParent, toParent)
      if (toParent) {
        if (!toParent.children) {
          toParent = toParent.parent
        }
        if (itemSelected.own && toParent.own) {
          // ---(HOME) --- WE ARE IN OUR OWN ACCOUNT FOLDER OR WE ARE ADMINS
          if (itemSelected.user_id == toParent.user_id || this.is_admin) {
            if (toParent.key == itemSelected.key || toParent.key === itemSelected.parentKey) {
              // --- DO NOTHING ---
            } else if (!this.testIsParent(itemSelected, toParent)) {
              let folderId = toParent.id
              if (toParent.datatype == 'account') { folderId = '' }
              if (itemSelected.children) { // FOLDER
                new Folder(this.$api).update(itemSelected.id, folderId)
                  .then(res => {
                    console.log('checkEnd - FOLDER MOVED:', res)
                    objFrom.splice(objFrom.indexOf(itemSelected), 1)
                    itemSelected.parentKey = toParent.key
                    itemSelected.parent = toParent
                    if (res.folder._attributes.parent_id) {
                      itemSelected.folder_id = res.folder._attributes.parent_id
                    } else {
                      delete itemSelected.folder_id
                    }
                    toParent.children.push(itemSelected)
                    toParent.children.sort(this.compItems) // sort by FullName
                  })
              } else { // LEAF
                new Search(this.$api).move(itemSelected.id, folderId)
                  .then(res => {
                    console.log('checkEnd - SEARCH MOVED:', res)
                    objFrom.splice(objFrom.indexOf(itemSelected), 1)
                    itemSelected.parentKey = toParent.key
                    itemSelected.parent = toParent
                    if (res.query._attributes.folder_id) {
                      itemSelected.folder_id = res.query._attributes.folder_id
                    } else {
                      delete itemSelected.folder_id
                    }
                    toParent.children.push(itemSelected)
                    toParent.children.sort(this.compItems) // sort by FullName
                  })
              }
            } else {
              this.$store.commit('showMessage', {title: '', color: 'orange', content: this.$t('NAVI_NODROP_SUBFOLDER')})
            }
          }
        } else {
          this.$store.commit('showMessage', {title: '', color: 'orange', content: this.$t('NAVI_NODROP_NOT_OWNER')})
        }
      }
      return false;
    },
    testIsParent(itemSelected, toParent) {
      if (toParent.parentKey === itemSelected.key) {
        return true
      } else if (toParent.parent) {
        return this.testIsParent(itemSelected, toParent.parent)
      }
      return false
    },
    mapRootFoldersAndSearches(acc, folders, searches) {
      const user_id = acc.id
      let children = []
      for (const i in folders) {
        let f = folders[i]
        if (!f.parent_id && user_id === f.user_id && f.type === '1') {
          // add folder to root account
// console.log('add folder to root account', user_id, f)
          f.key = `f${f.id}`
          // f.label = `${f.name}`
          Vue.set(f, 'label', `${f.name}`)
          // f.label = `${f.name} (${f.id})`
          f.datatype = 'folder'
          f.parent = acc
          f.parentKey = 'a' + user_id
          f.own = (f.user_id === this.user_id) || this.is_admin
          Vue.set(f, 'children', [...this.mapFoldersToFolder(f, folders, searches), ...this.mapSearchesToFolder(f, searches)])
          // f.icon = 'mdi-folder'
          children.push(f)
        }
      }
      // root searches
      for (const i in searches) {
        let s = searches[i]
        if (!s.folder_id && user_id === s.user_id) {
          // add search to root account
// console.log('add search to root account', s.user_id, s)
          s.key = `s${s.id}`
          // s.label = `${s.name}`
          Vue.set(s, 'label', `${s.name}`)
          s.datatype = s.type
          // s.label = `${s.name} (${s.id})`
          s.parent = acc
          s.parentKey = 'a' + user_id
          s.own = (s.user_id === this.user_id) || this.is_admin
          s.icon = s.type === 'group' ? 'mdi-account-group' : 'mdi-magnify'
          children.push(s)
        }
      }
      children.sort(this.compItems)
      return children || []
    },
    mapFoldersToFolder(folder, folders, searches) {
      let children = []
      for (const i in folders) {
        let f = folders[i]
        if (f.parent_id === folder.id) {
          // add folder to folder
// console.log('add folder to folder', f.parent_id, folder.id)
          f.key = `f${f.id}`
          // f.label = `${f.name}`
          Vue.set(f, 'label', `${f.name}`)
          // f.label = `${f.name} (${f.id})`
          f.datatype = 'folder'
          f.own = (f.user_id === this.user_id) || this.is_admin
          Vue.set(f, 'children', [...this.mapFoldersToFolder(f, folders, searches), ...this.mapSearchesToFolder(f, searches)])
          // f.icon = 'mdi-folder'
          f.parent = folder
          f.parentKey = folder.key
          children.push(f)
        }
      }
      children.sort(this.compItems)
      return children || []
    },
    mapSearchesToFolder(folder, searches) {
      let children = []
      for (const i in searches) {
        let s = searches[i]
        if (s.folder_id === folder.id) {
          // add search to folder
// console.log('add search to folder', s.user_id, folder.id)
          s.key = `s${s.id}`
          // s.label = `${s.name}`
          Vue.set(s, 'label', `${s.name}`)
          s.datatype = s.type
          // s.label = `${s.name} (${s.id})`
          s.own = (s.user_id === this.user_id) || this.is_admin
          s.icon = s.type === 'group' ? 'mdi-account-group' : 'mdi-magnify'
          s.parent = folder
          s.parentKey = folder.key
          children.push(s)
        }
      }
      children.sort(this.compItems)
      return children || []
    },
    // iterate over accounts ONLY
    filterTree(tree) {
      let users = tree.map(a => {return {...a}})
      for (let i in users) {
        if (users[i].children && users[i].children.length) {
          users[i].children = this.filterBranch(users[i].children).map(a => {return {...a}})
        }
      }
      return users
    },
    // iterate over all folders and shed off children
    filterBranch(branch) {
      let items = branch.map(a => {return {...a}})
      for (let i in items) {
        if (items[i].children && items[i].children.length) {
          items[i].children = this.filterBranch(items[i].children).map(a => {return {...a}})
        }
      }
      // actual filter
      return items.filter(this.filterFunction)
    },
    filterFunction(item) {
      if (item.label && this.filter && item.label.toLowerCase().indexOf(this.filter.toLowerCase()) > -1) {
        return true
      }
      if (item.children && item.children.length) {
        return true
      }
      if (item.parent && item.parent.label && item.parent.label.toLowerCase().indexOf(this.filter.toLowerCase()) > -1) {
        return true
      }
// console.log(item)
      return false
    },
    openMenu(e, item) {
      e.stopPropagation()
      let folderItem = null
      if (item.own) {
        if (item.datatype === 'folder') {
          folderItem = item           // FOLDER
        } else if (item.folder_id) {
          folderItem = item.parent    // Item in FOLDER
        }
      }
      this.$store.commit('setSelectedFolder', folderItem)
      this.contextItem = item
      this.active = [item]
      this.contextMenuVisible = false
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.contextMenuVisible = true
      })
    },
    contextMenuCallback(idx) {
// console.log('contextMenuCallback', idx)
      if (this.contextMenuComputed[idx].callback) {
        if (typeof this[this.contextMenuComputed[idx].callback] === 'function') {
          this[this.contextMenuComputed[idx].callback](this.contextItem)
        } else
        if (typeof this.contextMenuComputed[idx].callback === 'function') {
          this.contextMenuComputed[idx].callback(this.contextItem)
        }
      }
    },

    onItemClick(item) {
// console.log('onItemClick', item)
      if (item.datatype === 'account' || item.datatype === 'folder') {
        this.open.indexOf(item) > -1 ? this.open.splice(this.open.indexOf(item), 1) : this.open.push(item)
      }
      let folderItem = null
      if (item.own) {
        if (item.datatype === 'folder') {
          folderItem = item           // FOLDER
        } else if (item.folder_id) {
          folderItem = item.parent    // Item in FOLDER
        }
      }
      this.$store.commit('setSelectedFolder', folderItem)
    },
    onItemDblClick(item) {
// console.log('onItemDblClick', item)
      if (item.datatype === 'search') {
        this.runSearch(item)
      }
      if (item.datatype === 'group') {
        this.runGroup(item)
      }
    },
    onNewFolder(item = false) {
      if (!item) {
        this.$store.commit('setSelectedFolder', null)
      }
      this.showNameFolderDlg = true
    },
    onCreateFolder(name) {
// console.log('onCreateFolder', name)
      if(!name || !name.trim().length) {
        this.$store.commit('showMessage', {color: 'red', title: this.$t('NAVI_NEW_FOLDER_TT'), content: 'The folder name should not be empty!'})
        return
      }
      const folder = this.selectedFolder ? this.selectedFolder.datatype === 'folder'? this.selectedFolder : this.selectedFolder.parent : null
      const FOLDER = new Folder(this.$api)
      FOLDER.create(name, 1, folder)
        .then(() => {
          new Folder(this.$api).list()
        })
    },
    onNewSearch(item = false) {
      if (!item) {
        this.$store.commit('setSelectedFolder', null)
      }
      this.$store.commit('setIsUnsavedXml', false)
      // reset checkbox selection
      this.$store.commit('setAllToExport', false)
      this.$store.commit('setExportIds', [])
      // redirect
      this.$router.push({ name: 'search', params: { id: 'new' }, hash: this.getNewHash()})
    },
    onRenameFolder(name) {
// console.log('onRenameFolder', this.active, name)
      if (this.active && this.active.length) {
        new Folder(this.$api).rename(this.active[0].id, name)
        .then(() => {
          new Folder(this.$api).list()
        })
      }
    },
    deleteFolder(item) {
// console.log('deleteFolder', item)
      if (item.children.length) {
        this.$refs.dialog.show({
          type: '',
          title: this.$t('GENERIC_DELETE_ALERT_TITLE'),
          message: this.$t('NAVI_FOLDER_WITH_CHILDREN'),
          buttons: [
            {
              label: this.$t('GENERIC_DELETE'),
              close: true,
              // default: true,
              danger: true,
              callback: () => {
// console.log(`new Folder(this.$api).delete(${item.id})`)
                new Folder(this.$api).delete(item.id)
                .then(() => {
                  new Folder(this.$api).list()
                })
              }
            },
            {
              label: this.$t('GENERIC_CANCEL'),
              close: true,
              // default: true,
              // callback: res => {},
            },
          ]
        })
      } else {
// console.log(`new Folder(this.$api).delete(${item.id})`)
        new Folder(this.$api).delete(item.id)
        .then(() => {
          new Folder(this.$api).list()
        })
      }
    },
    runSearch(item) {
// console.log('runSearch', item)
      // reset checkbox selection
      this.$store.commit('setAllToExport', false)
      this.$store.commit('setExportIds', [])
      // redirect
      this.$router.push({ name: 'contact.extended_search', params: { search_id: item.id, title: item.label }, hash: this.getNewHash()})
    },
    editSearch(item) {
      // reset checkbox selection
      this.$store.commit('setAllToExport', false)
      this.$store.commit('setExportIds', [])
      // redirect
      this.$router.push({ name: 'search', params: { id: item.id, title: item.label }, hash: this.getNewHash()})
    },
    onRenameSearch(name) {
// console.log('onRenameSearch', this.active, name)
      if (this.active && this.active.length) {
        new Search(this.$api).rename(this.active[0].id, name)
        .then(() => {
          new Search(this.$api).list()
        })
      }
    },
    deleteSearch(item) {
      this.$refs.dialog.show({
        type: '',
        title: this.$t('GENERIC_DELETE_ALERT_TITLE'),
        message: this.$t('NAVI_CONFIRM_DELETE_SEARCH', [item.name]),
        buttons: [
          {
            label: this.$t('GENERIC_DELETE'),
            close: true,
            // default: true,
            danger: true,
            callback: () => {
// console.log('is_in_use')
              new Search(this.$api).is_in_use(item.id)
              .then(() => {
// console.log('delete', this.searchIsInUse)
                if (!this.searchIsInUse) {
                  new Search(this.$api).delete(item.id)
                  .then(() => {
                    new Search(this.$api).list()
                  })
                } else {

                  // TODO: implement Critical usage // EXTSEARCH_USAGE_DELETION_IMPOSSIBLE

                  let mailings = '<pre>Status : Name\n' + this.searchUsedInMailings.map(a => `${a.status} : ${a.name}\n`) + '</pre>'
                  this.$refs.dialog.show({
                    type: '',
                    title: this.$t('EXTSEARCH_USAGE_DELETION_POSSIBLE'),
                    message: this.$t('EXTSEARCH_USAGE_PANEL_DESC') + mailings,
                    buttons: [
                      {
                        label: this.$t('GENERIC_DELETE'),
                        close: true,
                        // default: true,
                        danger: true,
                        callback: () => {
// console.log('is_in_use & delete')
                          new Search(this.$api).delete(item.id)
                          .then(() => {
                            new Search(this.$api).list()
                          })
                        }
                      },
                      {
                        label: this.$t('GENERIC_CANCEL'),
                        close: true,
                        // default: true,
                        // callback: res => {},
                      },
                    ]
                  })
                }
              })
            },
          },
          {
            label: this.$t('GENERIC_CANCEL'),
            close: true,
            // default: true,
            // callback: res => {},
          },
        ]
      })
    },

    onNewGroup(item = false) {
      if (!item) {
        this.$store.commit('setSelectedFolder', null)
      }
      // reset checkbox selection
      this.$store.commit('setAllToExport', false)
      this.$store.commit('setExportIds', [])
      // redirect
      this.$router.push({ name: 'group', params: { group_id: 'new' }, hash: this.getNewHash()})
    },
    runGroup(item) {
// console.log('runGroup', item)
      // reset checkbox selection
      this.$store.commit('setAllToExport', false)
      this.$store.commit('setExportIds', [])
      // redirect
      this.$router.push({ name: 'contact.group', params: { search_id: item.id, title: item.label }, hash: this.getNewHash()})
    },
    editGroup(item) {
      // reset checkbox selection
      this.$store.commit('setAllToExport', false)
      this.$store.commit('setExportIds', [])
      // redirect
      this.$router.push({ name: 'group', params: { group_id: item.id, title: item.label }, hash: this.getNewHash()})
    },
    onRenameGroup(name) {
      if (this.active && this.active.length) {
        new Search(this.$api).rename(this.active[0].id, name)
        .then(() => {
          new Search(this.$api).list()
        })
      }
    },
    deleteGroup() {
      // NOTE: use deleteSearch instead
    },
    onUpdateOpen(val) {
// console.log('onUpdateOpen', val)
      this.open = val
    },
    onUpdateActive(val) {
// console.log('onUpdateActive', val)
      this.active = val
    },
    getNewHash() {
      const dt = new Date()
      return '##'+ (dt.getTime()*1000 + dt.getMilliseconds())
    }
  },
}
</script>

<style scoped lang="scss">
.v-btn {
  margin: 0;
}
.v-toolbar {
  .v-toolbar__content {
    padding: 0 12px;
  }
}
.v-treeview {
  .v-treeview-node {
    .v-icon--link.mdi-dots-vertical {
      opacity: 0;
      transition: opacity 0s;
      // fix menu dots for longer labels
      position: absolute;
      right: 0;
      background: rgba(206, 215, 201, 0.9);
    }
  }
  .v-treeview-node__children .v-treeview-node {
    margin-left: 11px;
  }
  .v-treeview-node__children .v-treeview-node--leaf {
    margin-left: 35px;
  }
  .v-treeview-node.v-treeview-node--active > .v-treeview-node__root,
  .v-treeview-node .v-treeview-node__root:hover {
    .v-icon--link.mdi-dots-vertical {
      opacity: 1;
    }
  }
  .v-treeview-node__label {
    margin-right: 6px;
  }
  @media screen and (min-width: 1025px) {
    .v-treeview-node__root {
      height: 24px;
      min-height: 24px;
    }
    .v-icon {
      font-size: 16px;
    }
    .v-treeview-node__label {
      // font-size: 0.8rem;
      font-size: 1rem; // CR
      margin-right: 6px;
    }
  }
}
.v-list {
  @media screen and (min-width: 1025px) {
    .v-list__tile {
      font-size: 12px;
      height: 24px;
    }
  }
}
</style>
